/*
 * Registry of standalone views mounted under `/view/:viewId`.
 *
 * Views listed here render OUTSIDE the default app layout (no header, side nav,
 * background grid, etc.). Each view is responsible for defining its own main
 * layout. To add a view, map its `viewId` to a component:
 *
 *   import { MyView } from "./my-view/MyView";
 *
 *   export const views = {
 *     "my-view": MyView,
 *   };
 *
 * The matched component is rendered under `/view/:viewId/*`, so a view may
 * declare its own nested `<Routes>` relative to `/view/:viewId`.
 */

export const views = {};
